import NextImage from 'next/image'

import { PageHeroProps } from '@/organisms/PageHero/ts'
import { Media } from '@/templates/Media/Media'
import FansiKind from '@/ts/enums/global/FansiKind'

function Mobile({ kind }: PageHeroProps) {
  const src = `/assets/page-hero/mobile/${kind}.png`
  const height = kind === FansiKind.FansiClass ? '60px' : '50px'

  return (
    <Media className="flex justify-center" lessThan="2md">
      <figure className="w-full max-w-md">
        <NextImage
          alt={kind}
          src={src}
          height={height}
          width="100%"
          layout="responsive"
          priority
          quality={75}
        />
      </figure>
    </Media>
  )
}

export default Mobile
